export default __webpack_public_path__ + "static/media/IMG_2177cropped.1a7229cb.jpeg";